<template>
  <div class="profil-container" v-if="legalitasForm.length > 0">
    <h3 class="profil-title" v-if="formIsActive(legalitasForm[0])">{{ legalitasForm[0].text }}</h3>
    <p class="profil-subtitle" v-if="formIsActive(legalitasForm[1])">{{ legalitasForm[1].text }}</p>

    <div class="legalitas-wrapper">
      <div class="vendor-form-wrapper legalitas-padding">
        <div class="vendor-form" v-for="(list, index) in legalitasForm.slice(2)" :key="index" v-if="formIsActive(list)">
          <p class="vendor-form-label">
            {{ list.text }}<span v-if="list.is_mandatory" class="text-ast">*</span>
          </p>

          <div class="form-list-usaha" v-if="list.name == 'Legal Document-3'">
            <div class="list-usaha">
              <div class="list-usaha-content list-usaha-content__title">
                <p class="column25 mr10">Dokumen</p>
                <p class="column25">Tanggal Efektif</p>
                <p class="column25">Tanggal Berakhir</p>
                <p class="column25"></p>
              </div>
              <div v-for="(list, index) in addedAktaPerusahaan" :key="index">
                <div class="list-usaha-content" v-if="list['checked']">
                  <p class="column25 mr10 all-column">{{ list.desc }}</p>
                  <p class="column25">
                    <input style="width: 90%" type="date" v-model="addedAktaPerusahaan[index]['start_date']" max="9999-12-31"/>
                  </p>
                  <p class="column25">
                    <input style="width: 90%" type="date" v-model="addedAktaPerusahaan[index]['end_date']" max="9999-12-31"/>
                  </p>
                  <p class="column20">
                    <label class="btn btn-default btn-file column100">
                      <i class="fas fa-upload"></i>
                      <span class="all-column">{{
                        $get(list, 'fileName', 'Upload')
                        }}</span>
                      <input type="file" style="display: none;" @change="fileAktaChangeHandler($event, index)" />
                    </label>
                  </p>
                  <p class="column5 cursor-pointer" @click="downloadFile(list.lampiran)">
                    <i class="fas fa-download"></i>Unduh
                  </p>
                </div>
              </div>
            </div>
            <div @click="openModalAktaPerusahaan()" class="btn-landing-icons">
              <p class="icons-btn-landing">+</p>
              <a class="text-btn-landing">Tambah</a>
            </div>
          </div>

          <div class="form-list-usaha" v-if="list.name == 'Legal Document-4'">
            <div class="list-usaha">
              <div class="list-usaha-content list-usaha-content__title">
                <p class="column35 mr10">Dokumen</p>
                <p class="column40">Keterangan</p>
                <p class="column25"></p>
              </div>
              <div v-for="(list, index) in addedKomersial" :key="index">
                <div class="list-usaha-content" v-if="list['checked']">
                  <p class="column35 mr10 all-column">{{ list.desc }}</p>
                  <div class="column40">
                    <the-mask v-if="list.id == 5" style="width: 90%" :mask="['##.###.###.#-###.###']"
                      placeholder="XX.XXX.XXX.X-XXX.XXX" v-model="addedKomersial[index]['keterangan']" disabled />
                    <input v-else style="width: 90%" type="text" v-model="addedKomersial[index]['keterangan']" />
                  </div>
                  <p class="column20">
                    <label class="btn btn-default btn-file column100">
                      <i class="fas fa-upload"></i>
                      <span class="all-column">{{
                        $get(list, 'fileName')
                        }}</span>
                      <input type="file" style="display: none;" @change="fileKomersialChangeHandler($event, index)" />
                    </label>
                  </p>
                  <p class="column5 cursor-pointer" @click="downloadFile(list.lampiran)">
                    <i class="fas fa-download"></i>Unduh
                  </p>
                </div>
              </div>

              <div @click="openModalKomersial()" class="btn-landing-icons">
                <p class="icons-btn-landing">+</p>
                <a class="text-btn-landing">Tambah</a>
              </div>
            </div>
          </div>

          <div class="form-list-usaha" v-if="list.name == 'Legal Document-5'">
            <div class="list-usaha">
              <div class="list-usaha-content list-usaha-content__title">
                <p class="column25 mr10">Dokumen</p>
                <p class="column25">Tanggal Efektif</p>
                <p class="column25">Tanggal Berakhir</p>
              </div>
              <div v-for="(list, index) in addedPerizinan" :key="index">
                <div class="list-usaha-content" v-if="list['checked']">
                  <p class="column25 mr10 all-column">{{ list.desc }}</p>
                  <p class="column25">
                    <input style="width: 90%" type="date" v-model="addedPerizinan[index]['start_date']" max="9999-12-31"/>
                  </p>
                  <p class="column25">
                    <input style="width: 90%" type="date" v-model="addedPerizinan[index]['end_date']" max="9999-12-31"/>
                  </p>
                  <p class="column20">
                    <label class="btn btn-default btn-file column100">
                      <i class="fas fa-upload"></i>
                      <span class="all-column">{{
                        $get(list, 'fileName', 'Upload')
                        }}</span>
                      <input type="file" style="display: none;" @change="filePerizinanChangeHandler($event, index)" />
                    </label>
                  </p>
                  <p class="column5 cursor-pointer" @click="downloadFile(list.lampiran)">
                    <i class="fas fa-download"></i>Unduh
                  </p>
                </div>
              </div>
              <div @click="openModalPerizinan()" class="btn-landing-icons">
                <p class="icons-btn-landing">+</p>
                <a class="text-btn-landing">Tambah</a>
              </div>
            </div>
          </div>

          <master-data-input-list :list="list" :step="'md_step_6'" :i="index" v-if="list.question_type !== 'default'" />
        </div>
      </div>

      <hr />
      <div class="vendor-form-wrapper legalitas-padding">
        <div class="vendor-form">
          <div class="legalitas-form-label">Logo Perusahaan</div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ logoFileName }}</span>
                    <input type="file" style="display: none;" @change="fileLogoChangeHandler" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div v-if="this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') != 2" class="legalitas-form-label">
            Surat Pakta Integritas yang sudah di tanda tangan basah oleh
            Direktur Utama Perusahaan diatas materai Rp 10.000
          </div>
          <div v-else class="legalitas-form-label">
            Integrity Pact Letter signed by an authorized representative of the Company, either physically or
            electronically
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label v-if="this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') != 2"
                    class="btn btn-default btn-file column100" @click="paktaIntegritas()">
                    <i class="fas fa-download"></i> <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                  <label v-else class="btn btn-default btn-file column100" @click="paktaIntegritas()">
                    <i class="fas fa-download"></i> <span>Download Template</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span>{{ paktaFileName }}</span>
                    <input type="file" style="display: none;" @change="filePaktaChangeHandler" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div v-if="this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') != 2" class="legalitas-form-label">
            Formulir vendor yang sudah di tanda tangan basah oleh Direktur Utama
            Perusahaan diatas materai Rp 10.000
          </div>
          <div v-else class="legalitas-form-label">
            Vendor form signed by the Director of the Company, either physically or electronically
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label v-if="this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') != 2"
                    class="btn btn-default btn-file column100" @click="pdfFormVendor()">
                    <i class="fas fa-download"></i> <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                  <label v-else class="btn btn-default btn-file column100" @click="pdfFormVendor()">
                    <i class="fas fa-download"></i> <span>Download Template</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span>{{ formulirFileName }}</span>
                    <input type="file" style="display: none;" @change="fileFormulirChangeHandler" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form"
          v-if="checkKomersial(addedKomersial) && this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') == 1">
          <div class="legalitas-form-label">
            Surat Keterangan Perusahaan non PKP yang sudah di tanda tangan basah
            oleh Direktur Utama Perusahaan diatas materai Rp 10.000
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label class="btn btn-default btn-file column100" @click="pdfNonPkp()">
                    <i class="fas fa-download"></i> <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span>{{ suratFileName }}</span>
                    <input type="file" style="display: none;" @change="fileSuratChangeHandler" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goSelesai()" class="btn-landing">Selanjutnya</div>
    </div>

    <AddAktaPerusahaan v-if="$store.state.landingpage.addAktaPerusahaan" />
    <AddKomersial v-if="$store.state.landingpage.addKomersial" />
    <AddPerizinan v-if="$store.state.landingpage.addPerizinan" />
  </div>
</template>

<script>
import { api } from '../../services/config'
import axios from 'axios'

export default {
  components: {
    AddAktaPerusahaan: () =>
      import('@/components/modalLandingPage/addAktaPerusahaan.vue'),
    AddKomersial: () =>
      import('@/components/modalLandingPage/addKomersial.vue'),
    AddPerizinan: () =>
      import('@/components/modalLandingPage/addPerizinan.vue'),
  },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  created() { },
  computed: {
    tipe_pendaftaran() {
      return this.$get(this.$store, 'state.landingpage.type_pendaftaran_id')
    },
    legalitasForm() {
      return this.$store.state.landingpage.md_step_6
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
    logoFileName() {
      if (
        this.$store.state.landingpage.logoFiles.length > 0 &&
        'name' in this.$store.state.landingpage.logoFiles[0]
      ) {
        return this.$store.state.landingpage.logoFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.logoFileName')) {
        return this.$get(this.$store, 'state.landingpage.logoFileName')
      }

      return this.labelPlaceholder
    },
    paktaFileName() {
      if (
        this.$store.state.landingpage.paktaFiles.length > 0 &&
        'name' in this.$store.state.landingpage.paktaFiles[0]
      ) {
        return this.$store.state.landingpage.paktaFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.paktaFileName')) {
        return this.$get(this.$store, 'state.landingpage.paktaFileName')
      }

      return this.labelPlaceholder
    },
    formulirFileName() {
      if (
        this.$store.state.landingpage.formulirFiles.length > 0 &&
        'name' in this.$store.state.landingpage.formulirFiles[0]
      ) {
        return this.$store.state.landingpage.formulirFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.formulirFileName')) {
        return this.$get(this.$store, 'state.landingpage.formulirFileName')
      }

      return this.labelPlaceholder
    },
    suratFileName() {
      if (
        this.$store.state.landingpage.suratFiles.length > 0 &&
        'name' in this.$store.state.landingpage.suratFiles[0]
      ) {
        return this.$store.state.landingpage.suratFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.suratFileName')) {
        return this.$get(this.$store, 'state.landingpage.suratFileName')
      }

      return this.labelPlaceholder
    },
    addedAktaPerusahaan: function () {
      return this.$store.state.landingpage.addedAktaPerusahaan
    },
    addedKomersial: function () {
      return this.$store.state.landingpage.addedKomersial
    },
    addedPerizinan: function () {
      return this.$store.state.landingpage.addedPerizinan
    },
  },
  methods: {
    checkSurat(arr) {
      const {
        suratFiles,
        formulirFiles,
        paktaFiles,
      } = this.$store.state.landingpage
        
        if (this.$route.path.split('/')[1] == 'pra-legal') {
          if (this.suratFileName && this.formulirFileName && this.paktaFileName) {
            return true;
          } else {
            if (!formulirFiles || formulirFiles.length == 0) {
                arr.push([false, 'Pengajuan Anda belum berhasil Pastikan Anda telah melampirkan Dokumen Form Vendor, Form Pakta Integritas dan atau Surat Keterangan Non PKP. Untuk informasi lebih lanjut, silakan kontak sipm_member_team@sinarmasmining.com']);
              return this.multiCustomConditions(arr);
  
            } else if (!paktaFiles || paktaFiles.length == 0) {
  
                arr.push([false, 'Pengajuan Anda belum berhasil Pastikan Anda telah melampirkan Dokumen Form Vendor, Form Pakta Integritas dan atau Surat Keterangan Non PKP. Untuk informasi lebih lanjut, silakan kontak sipm_member_team@sinarmasmining.com']);
              return this.multiCustomConditions(arr);
            } else if ( this.checkKomersial(this.addedKomersial) && (!suratFiles || suratFiles.length == 0)) {
  
                arr.push([false, 'Pengajuan Anda belum berhasil Pastikan Anda telah melampirkan Dokumen Form Vendor, Form Pakta Integritas dan atau Surat Keterangan Non PKP. Untuk informasi lebih lanjut, silakan kontak sipm_member_team@sinarmasmining.com']);
              return this.multiCustomConditions(arr);
            }
          }
        }
      
      return true;
    },

    checkForm() {
      const {
        addedAktaPerusahaan,
      } = this.$store.state.landingpage

      let arr = []
      let legalitas = this.legalitasForm.slice(2)

      if (this.tipe_pendaftaran == 1) {
        const checkSuratResult = this.checkSurat(arr);
          if (checkSuratResult !== true) {
            return checkSuratResult;
          }
      }

      for (let i in legalitas) {
        if (legalitas[i].name == 'Legal Document-3' && legalitas[i].is_mandatory && legalitas[i].is_active) { 
          arr.push([addedAktaPerusahaan.length > 0, legalitas[i].text]) }
        else if (legalitas[i].name == 'Legal Document-4' && legalitas[i].is_mandatory && legalitas[i].is_active) { 
          arr.push([this.addedKomersial.length > 0, legalitas[i].text]) 
        }
        else if (legalitas[i].name == 'Legal Document-5' && legalitas[i].is_mandatory && legalitas[i].is_active) { 
          arr.push([this.addedPerizinan.length > 0, legalitas[i].text]) 
        }
        else if (!legalitas[i].is_default && legalitas[i].is_active && legalitas[i].is_mandatory) {
          arr.push([legalitas[i].form_value, legalitas[i].text])
        }
      }

      // if (!addedAktaPerusahaan.length > 0) {
      //   arr = [...arr, ['', 'Akta Perusahaan']]
      // }
      // if (!this.addedKomersial.length > 0) {
      //   arr = [...arr, ['', 'Komersial']]
      // }
      // if (!this.addedPerizinan.length > 0) {
      //   arr = [...arr, ['', 'Perizinan']]
      // }

      if (addedAktaPerusahaan.length > 0) {
        let aktaPerusahaan = [...addedAktaPerusahaan]

        for (let i in aktaPerusahaan) {
          if (!aktaPerusahaan[i].fileName && aktaPerusahaan[i].checked) {
            arr = [
              ...arr,
              [
                aktaPerusahaan[i].file && aktaPerusahaan[i].file.length > 0,
                `Akta Perusahaan: ${aktaPerusahaan[i].desc}`,
              ],
            ]
          }
          if (!aktaPerusahaan[i].end_date && aktaPerusahaan[i].checked) {
            arr = [
              ...arr,
              [
                aktaPerusahaan[i].end_date,
                `Akta Perusahaan - Tanggal Berakhir: ${aktaPerusahaan[i].desc}`,
              ],
            ]
          }
        }
      }

      if (this.addedKomersial.length > 0) {
        let komersil = [...this.addedKomersial]

        for (let i in komersil) {
          if (!komersil[i].fileName && komersil[i].checked) {
            arr = [
              ...arr,
              [
                komersil[i].file && komersil[i].file.length > 0,
                `Komersil: ${komersil[i].desc}`,
              ],
            ]
          }
        }
      }

      if (
        this.addedKomersial.length > 0 &&
        this.addedKomersial.filter(i => i.checked).length == 0
      ) {
        let komersil = [...this.addedKomersial]

        arr = [...arr, [komersil.filter(i => i.checked).length > 0, `Komersil`]]
      }

      if (this.addedPerizinan.length > 0) {
        let izin = [...this.addedPerizinan]

        for (let i in izin) {
          if (!izin[i].fileName && izin[i].checked) {
            arr = [
              ...arr,
              [
                izin[i].file && izin[i].file.length > 0,
                `Perizinan: ${izin[i].desc}`,
              ],
            ]
          }
          if (!izin[i].end_date && izin[i].checked) {
            arr = [
              ...arr,
              [
                izin[i].end_date,
                `Perizinan - Tanggal berakhir: ${izin[i].desc}`,
              ],
            ]
          }
        }
      }

      if (
        this.addedPerizinan.length > 0 &&
        this.addedPerizinan.filter(i => i.checked).length == 0
      ) {
        let perizinan = [...this.addedPerizinan]

        arr = [
          ...arr,
          [perizinan.filter(i => i.checked).length > 0, `Perizinan`],
        ]
      }


      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
    },
    goSelesai() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'selesai')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'end_step',
          value: true,
        })
      }
    },
    checkKomersial(value) {
      const komersial =
        value &&
        value.filter(
          i => i.checked && i.desc == 'SPPKP (SK PENGUKUHAN KENA PAJAK)'
        )

      if (komersial.length > 0) {
        return false
      }

      return true
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    fileLogoChangeHandler(e) {
      let logoFiles = Array.from(e.target.files)
      if (this.imageFileValidation(logoFiles[0].name)) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'logoFiles',
          value: logoFiles,
        })
      } else {
        this.$store.commit(
          'SET_NOTIF',
          'Hanya gunakan file type: png,jpg, jpeg, BMP'
        )
      }
    },
    filePaktaChangeHandler(e) {
      const file = e.target.files[0];
      const maxSize = 2097152

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 2MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      } else {
        let paktaFiles = Array.from(e.target.files)
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'paktaFiles',
          value: paktaFiles,
        })
      }
    },
    fileFormulirChangeHandler(e) {
      const file = e.target.files[0];
      const maxSize = 2097152

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 2MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      } else {
        let formulirFiles = Array.from(e.target.files)
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'formulirFiles',
          value: formulirFiles,
        })
      }
    },
    fileSuratChangeHandler(e) {
      const file = e.target.files[0];
      const maxSize = 1048576

        if (file.size > maxSize) {
          this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 1MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
        } else {
          let suratFiles = Array.from(e.target.files)
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'suratFiles',
            value: suratFiles,
          })
        }
    },
    fileAktaChangeHandler(e, i) {
      let oldAktaPerusahaan = this.$store.state.landingpage.addedAktaPerusahaan
      const file = e.target.files[0];
      const maxSize = 2097152

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 2MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      } else {
        let aktaFiles = Array.from(e.target.files)
  
        oldAktaPerusahaan[i]['file'] = aktaFiles
        oldAktaPerusahaan[i]['fileName'] = aktaFiles[0].name
  
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedAktaPerusahaan',
          value: [],
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedAktaPerusahaan',
          value: oldAktaPerusahaan,
        })
      }

    },
    fileKomersialChangeHandler(e, i) {
      let oldKomersial = this.$store.state.landingpage.addedKomersial
      const file = e.target.files[0];
      const maxSize = 2097152

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 2MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      } else {
        let komersialFiles = Array.from(e.target.files)

        oldKomersial[i]['file'] = komersialFiles
        oldKomersial[i]['fileName'] = komersialFiles[0].name

        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedKomersial',
          value: [],
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedKomersial',
          value: oldKomersial,
        })
      }
    },
    filePerizinanChangeHandler(e, i) {
      let oldPerizinan = this.$store.state.landingpage.addedPerizinan
      const file = e.target.files[0];
      const maxSize = 1048576

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 1MB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      } else {

        let perizinanFiles = Array.from(e.target.files)
  
        oldPerizinan[i]['file'] = perizinanFiles
        oldPerizinan[i]['fileName'] = perizinanFiles[0].name
  
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedPerizinan',
          value: [],
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'addedPerizinan',
          value: oldPerizinan,
        })
      }
    },
    openModalAktaPerusahaan() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addAktaPerusahaan',
        value: true,
      })
    },
    openModalKomersial() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomersial',
        value: true,
      })
    },
    openModalPerizinan() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPerizinan',
        value: true,
      })
    },
    generateAlamat() {
      if (this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63) {
        let alamat = this.$get(this.$store, 'state.landingpage.address', '')
        let kecamatan = this.$get(
          this.$store,
          'state.landingpage.choosedDistric.desc',
          ''
        )
        let kelurahan = this.$get(
          this.$store,
          'state.landingpage.choosedVillage.desc',
          ''
        )
        let kota = this.$get(
          this.$store,
          'state.landingpage.choosedCity.desc',
          ''
        )
        let provinsi = this.$get(
          this.$store,
          'state.landingpage.choosedProvince.desc',
          ''
        )
        let kodepos = this.$get(this.$store, 'state.landingpage.kodepos', '')

        let createAlamat = `${alamat} ${kecamatan &&
          `, ${kecamatan}`} ${kelurahan && `, ${kelurahan}`} ${kota &&
          `, ${kota}`} ${provinsi && `, ${provinsi}`} ${kodepos &&
          `, ${kodepos}`}`

        return createAlamat
      } else {
        let alamat = this.$get(this.$store, 'state.landingpage.address', '')
        let kota = this.$get(this.$store, 'state.landingpage.kotaAsing', '')
        let provinsi = this.$get(
          this.$store,
          'state.landingpage.provinsiAsing',
          ''
        )
        let kodepos = this.$get(this.$store, 'state.landingpage.kodepos', '')

        let alamatInter = `${alamat} ${kota && `, ${kota}`} ${provinsi &&
          `, ${provinsi}`} ${kodepos && `, ${kodepos}`}`

        return alamatInter
      }
    },
    paktaIntegritas() {
      let routeData = ''
      let dataForm = {
        nama: this.$get(
          this.$store,
          'state.landingpage.direkturList.0.nama',
          ''
        ),
        jabatan: 'Direktur Utama',
        perusahaan: this.$store.state.landingpage.vendorName,
        alamat: this.generateAlamat(),
      }

      routeData = this.$router.resolve({
        path: '/pdf/pakta-integritas',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    pdfNonPkp() {
      let dataForm = {
        nama: this.$get(
          this.$store,
          'state.landingpage.direkturList.0.nama',
          ''
        ),
        jabatan: 'Direktur Utama',
        perusahaan: this.$store.state.landingpage.vendorName,
        alamat: this.generateAlamat(),
      }

      let routeData = this.$router.resolve({
        path: '/pdf/surat-pernyataan-non-pkp',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    pdfFormVendor() {
      let routeData = ''
      let kec = ''
      let kota = ''
      if (this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63) {
        kec = `${this.$get(
          this.$store,
          'state.landingpage.choosedDistric.desc',
          ''
        )} ${`${this.$get(this.$store, 'state.landingpage.choosedVillage.desc')
          ? `, ${this.$get(
            this.$store,
            'state.landingpage.choosedVillage.desc'
          )}`
          : ''
        }`}`
        kota = `${this.$get(
          this.$store,
          'state.landingpage.choosedCity.desc',
          ''
        )} ${`${this.$get(this.$store, 'state.landingpage.choosedProvince.desc')
          ? `, ${this.$get(
            this.$store,
            'state.landingpage.choosedProvince.desc'
          )}`
          : ''
        }`}`
      } else {
        kec = ``
        kota = `${this.$get(
          this.$store,
          'state.landingpage.kotaAsing',
          ''
        )} ${`${this.$get(this.$store, 'state.landingpage.provinsiAsing')
          ? `, ${this.$get(this.$store, 'state.landingpage.provinsiAsing')}`
          : ''
        }`}`
      }

      let dataForm = {
        nama_vendor: this.$get(this.$store, 'state.landingpage.vendorName', ''),
        kbli1: this.$get(this.$store, 'state.landingpage.addedKbli.0.desc', ''),
        kbli2: this.$get(this.$store, 'state.landingpage.addedKbli.1.desc', ''),
        kbli3: this.$get(this.$store, 'state.landingpage.addedKbli.2.desc', ''),
        kec,
        kota,
        kodepos: this.$get(this.$store, 'state.landingpage.kodepos', ''),

        phone_dir: this.$get(
          this.$store,
          'state.landingpage.direkturList.0.phoneNumber',
          ''
        ),
        nama_pic: this.$get(
          this.$store,
          'state.landingpage.picList.0.nama',
          ''
        ),
        phone_pic: this.$get(
          this.$store,
          'state.landingpage.picList.0.phoneNumber',
          ''
        ),
        email_pic: this.$get(
          this.$store,
          'state.landingpage.picList.0.email',
          ''
        ),
        email: this.$get(this.$store, 'state.landingpage.emailPerusahaan', ''),
        email_direktur: this.$get(
          this.$store,
          'state.landingpage.direkturList.0.email',
          ''
        ),
        nama_bank: this.$get(this.$store, 'state.landingpage.selectedBank', ''),
        bank_cabang: this.$get(
          this.$store,
          'state.landingpage.bankBranchOffice',
          ''
        ),
        pemilik_rekening: this.$get(
          this.$store,
          'state.landingpage.pemilikBank',
          ''
        ),
        no_rek: this.$get(this.$store, 'state.landingpage.accountNumber', ''),
        mata_uang: this.$get(this.$store, 'state.landingpage.mataUang', ''),
        pemegang_saham1: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.0.nama',
          ''
        ),
        pemegang_saham2: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.1.nama',
          ''
        ),
        pemegang_saham3: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.2.nama',
          ''
        ),
        pemegang_saham4: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.3.nama',
          ''
        ),
        pemegang_saham5: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.4.nama',
          ''
        ),
        pemegang_saham6: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.5.nama',
          ''
        ),
        total_saham1: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.0.saham',
          ''
        ),
        total_saham2: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.1.saham',
          ''
        ),
        total_saham3: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.2.saham',
          ''
        ),
        total_saham4: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.3.saham',
          ''
        ),
        total_saham5: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.4.saham',
          ''
        ),
        total_saham6: this.$get(
          this.$store,
          'state.landingpage.pemilikSahamList.5.saham',
          ''
        ),
        direktur1: this.$get(
          this.$store,
          'state.landingpage.direkturList.1.nama',
          ''
        ),
        direktur2: this.$get(
          this.$store,
          'state.landingpage.direkturList.2.nama',
          ''
        ),
        komisaris1: this.$get(
          this.$store,
          'state.landingpage.komisarisList.0.nama',
          ''
        ),
        komisaris2: this.$get(
          this.$store,
          'state.landingpage.komisarisList.1.nama',
          ''
        ),
        komisaris3: this.$get(
          this.$store,
          'state.landingpage.komisarisList.2.nama',
          ''
        ),

        nama: this.$get(
          this.$store,
          'state.landingpage.direkturList.0.nama',
          ''
        ),
        afiliasi:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? 'YA'
            : 'TIDAK',
        relasi_desc:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_desc', '')
            : '',
        relasi_group:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_group', '')
            : '',
        relasi_jabatan:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_jabatan', '')
            : '',
        relasi_departemen:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_departemen', '')
            : '',
        relasi_nama:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_nama', '')
            : '',
        jabatan: 'Direktur Utama',
        perusahaan: this.$store.state.landingpage.vendorName,
        alamat: `${this.$get(this.$store, 'state.landingpage.address', '')}`,
      }

      let aktaPerusahaan = this.$store.state.landingpage.addedAktaPerusahaan
      for (let i in aktaPerusahaan) {
        dataForm[`akta${aktaPerusahaan[i]['id']}`] = aktaPerusahaan[i][
          'fileName'
        ]
          ? 'YES'
          : 'NO'

        dataForm[`akta${aktaPerusahaan[i]['id']}end`] = aktaPerusahaan[i][
          'end_date'
        ]
          ? aktaPerusahaan[i]['end_date']
          : '-'

        dataForm[`akta${aktaPerusahaan[i]['id']}keterangan`] = aktaPerusahaan[
          i
        ]['keterangan']
          ? aktaPerusahaan[i]['keterangan']
          : '-'
      }

      let aktaKomersial = this.$store.state.landingpage.addedKomersial
      for (let i in aktaKomersial) {
        dataForm[`akta${aktaKomersial[i]['id']}`] = aktaKomersial[i]['fileName']
          ? 'YES'
          : 'NO'

        dataForm[`akta${aktaKomersial[i]['id']}end`] = aktaKomersial[i][
          'end_date'
        ]
          ? aktaKomersial[i]['end_date']
          : '-'

        dataForm[`akta${aktaKomersial[i]['id']}keterangan`] = aktaKomersial[i][
          'keterangan'
        ]
          ? aktaKomersial[i]['keterangan']
          : '-'
      }

      let aktaPerizinan = this.$store.state.landingpage.addedPerizinan
      for (let i in aktaPerizinan) {
        if (aktaPerizinan[i]['checked']) {
          dataForm[`akta${aktaPerizinan[i]['id']}`] = aktaPerizinan[i][
            'fileName'
          ]
            ? 'YES'
            : 'NO'

          dataForm[`akta${aktaPerizinan[i]['id']}end`] = aktaPerizinan[i][
            'end_date'
          ]
            ? aktaPerizinan[i]['end_date']
            : '-'

          dataForm[`akta${aktaPerizinan[i]['id']}keterangan`] = aktaPerizinan[
            i
          ]['keterangan']
            ? aktaPerizinan[i]['keterangan']
            : '-'
        }
      }

      let direkturList = this.$store.state.landingpage.direkturList
      let komisarisList = this.$store.state.landingpage.komisarisList


      let isKTPDir =
        direkturList.filter(
          i => (i.lampiran && i.lampiran != '') || i.direkturFiles.length > 0
        ).length > 0
      let isKTPKom =
        komisarisList.filter(
          i => (i.lampiran && i.lampiran != '') || i.komisarisFiles.length > 0
        ).length > 0

      dataForm['akta3536'] = isKTPDir && isKTPKom ? 'YES' : 'NO'


      routeData = this.$router.resolve({
        path: '/pdf/form-vendor-bu',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    async downloadFile(link) {
      try {

        if (link) {
          let linkUrl = `${api}/file/${link}`
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
          await axios({
            url: linkUrl,
            method: 'GET',
            responseType: 'blob',
          })
            .then(async response => {
              let fileURL = window.URL.createObjectURL(
                new Blob([response.data])
              )
              let fileLink = document.createElement('a')

              fileLink.href = fileURL
              fileLink.setAttribute('download', this.$linkConverter(link))
              document.body.appendChild(fileLink)

              fileLink.click()

              await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            })
            .catch(async error => {
              await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            })
        }
      } catch (error) {
      }
    },
  },
}
</script>
